import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {LocaleService} from "../services/locale.service";

@Pipe({
    name: 'localeDecimal',
    standalone: true,
    pure: false
})
export class LocaleDecimalPipe implements PipeTransform {
    private currentLocale: string | undefined;

    constructor(private localeService: LocaleService) {
        this.localeService.currentLocale$.subscribe(locale => {
            this.currentLocale = locale;
        });
    }

    transform(value: any, format: string = '1.0-2'): string {
        if (value === null || value === undefined || this.currentLocale === undefined) return '';

        const pipe = new DecimalPipe(this.currentLocale);
        return <string>pipe.transform(value, format);
    }
}
